import { createStore, combineReducers, applyMiddleware, AnyAction } from "redux";
import { History } from "history";
import thunk from "redux-thunk";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { ApplicationState, buildReducers, CREATED, ReceiveAction, RECEIVE_ENCRYPTED_CUSTOMER } from "./";

import { RECEIVE_INITIAL, RECEIVE_PRICE } from "./actions";

import { datalayerMiddleware } from "../analytics";
import { composeWithDevTools } from "redux-devtools-extension";

let store: any;

export default function configureStore(history: History, initialState?: ApplicationState) {
  const root = (state: any, action: ReceiveAction | AnyAction) => {
    const initial = action as ReceiveAction;
    if (initial && initial.type === RECEIVE_INITIAL) {
      const { ui, inputs, router } = state;
      const addon = initial.payload?.addon;
      const distance = initial.payload?.distance;
      const footer = initial.payload?.footer;
      const profile = initial.payload?.profile;
      const singleRecomendation = initial.payload?.singleRecomendation;
      const payment = initial.payload?.payment;
      const insurance = initial.payload?.insurance;
      const texts = initial.payload?.texts;
      const damageFreeYear = initial.payload?.damageFreeYear;
      const youngDriver = initial.payload?.youngDriver;
      const campaign = initial.payload?.campaign;
      const dealerPrice = initial.payload?.dealerPrice;
      const usp = initial.payload?.usp;
      const signingService = initial.payload.signingService;
      state = {
        ui: {
          ...ui,
          initialized: true,
        },
        profile,
        addon,
        inputs,
        router,
        distance,
        footer,
        payment,
        singleRecomendation,
        insurance,
        texts,
        damageFreeYear,
        youngDriver,
        campaign,
        dealerPrice,
        usp,
        signingService,
      };
    }

    if (initial && initial.type === RECEIVE_PRICE) {
      const footer = initial.payload?.footer;
      const addon = initial.payload?.addon;
      const insurance = initial.payload?.insurance;
      state = { ...state, footer, addon, insurance };
    }

    if (initial && initial.type === RECEIVE_ENCRYPTED_CUSTOMER) {
      const profile = initial.payload?.profile;
      state = {
        ...state,
        profile: {
          ...state.profile,
          email: {
            ...state.profile.email,
            secureValue: profile.email.secureValue,
          },
          phone: {
            ...state.profile.phone,
            secureValue: profile.phone.secureValue,
          },
        },
      };
    }

    if (initial && initial.type === CREATED) {
      const signingService = initial.payload.signingService;
      state = { ...state, signingService };
    }

    if (!initialState) {
      state = { ...state, inputs: { ...state.inputs, redirectLink: "if.se" } }; //for storybook
    }

    return rootReducer(state, action);
  };

  const rootReducer = combineReducers({
    ...buildReducers(initialState?.inputs?.useCarApiV2 ? "v2" : "v1"),
    router: connectRouter(history),
  });

  const middleware = [thunk, routerMiddleware(history), datalayerMiddleware];

  const enhancers: any[] = [];

  store = createStore(
    root,
    {
      ui: initialState?.ui,
      inputs: initialState?.inputs,
    },
    // used instead of compose() to allow easier store debugging @ browsers Redux DevTools extension
    composeWithDevTools(applyMiddleware(...middleware), ...enhancers),
  );
  return store;
}
